export const removeAndReplaceAmpersand = str => str.replace(/&/g,`And`);
export const removeSpaces = str => str.replace(/[ ]/g, '');

export function restrictUserInput(input) {
    return input.substring(0, 120);
}

export function scrollToComments() {
    const something = document.getElementById("commentContainer");
    something?.scrollIntoView({ behavior: "smooth" });
    console.log("scroll called!");
}
